var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('i-table',{attrs:{"stripe":"","columns":_vm.titles,"data":_vm.items,"size":"small"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }